import CheckProducts from './CheckProducts';
import type { CheckProductsProps } from './CheckProducts.types';

export type { CheckProductsProps };

export { CheckProducts };
export default CheckProducts;
